import { Controller } from 'stimulus';

export default class extends Controller {
  toggleStartButton(event) {
    const buttonId = event.target.id + '_start_button';
    document.getElementById(buttonId).classList.toggle("opacity-0"); 
  }
}
